import {
  Autocomplete,
  Box,
  Button,
  ButtonGroup,
  Divider,
  styled,
  TextField,
  Typography
} from '@mui/material'
import calendarImage from '../../assets/calendar.svg'

export const WindowContainer = styled('div')({
  background: '#242428  !important',
  height: '100%',
  width: '100%'
})

export const Title = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
  textTransform: 'capitalize',
  fontFamily: 'Nunito',
  textAlign: 'center',
  fontSize: '18px',
  marginTop: '24px'
}))

export const DividerStyle = styled(Divider)(({ theme }) => ({
  border: `1px solid ${theme.palette.separators.primary}`
}))

export const DealBodyContainer = styled(Box)(() => ({
  paddingLeft: '32px',
  paddingRight: '32px'
}))

export const DealBodySubContainer = styled('form')(() => ({
  marginTop: '24px',
  marginBottom: '24px',
  display: 'grid',
  gap: '20px',
  width: '100%'
}))

export const TextFieldModalStyle = styled(TextField)(({ theme, myerror }) => {
  let border = 'none'
  if (myerror === 'true') {
    border = `1px solid ${theme.palette.button.delete.primary}`
  }
  return {
    backgroundColor: '#39393C',
    overflowY: 'auto',
    borderRadius: '4px',
    '& .Mui-error': {
      border
    }
  }
})

export const AutocompleteStyle = styled(Autocomplete)(({ theme, error }) => {
  let border = 'none'
  if (error) {
    border = `1px solid ${theme.palette.button.delete.primary}`
  }

  return {
    margin: 0,
    backgroundColor: theme.palette.separators.primary,
    border,
    width: '100%',
    height: '32px',
    borderRadius: '4px',
    '& .Mui-disabled': {
      backgroundColor: theme.palette.card.primary
    },
    '& .Mui-disabled .MuiSvgIcon-root': {
      color: theme.palette.switch.unactive
    },
    '& .MuiSvgIcon-root': {
      color: theme.palette.button.save.primary
    },
    '& .MuiAutocomplete-clearIndicator': {
      color: theme.palette.button.save.primary
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'transparent'
      },
      '&:hover:not(.Mui-disabled) fieldset': {
        borderColor: 'transparent' // Remove the hover border
      },
      '&.Mui-focused fieldset': {
        borderColor: 'transparent' // Remove the focus border
      }
    },
    '& .MuiAutocomplete-popupIndicator': {
      '&:hover': {
        backgroundColor: 'transparent' // Remove hover background color for the indicator
      }
    }
  }
})

export const UnVisibleSubmitButton = styled(Button)({
  display: 'none'
})

export const OptionContainer = styled('li')(() => ({
  display: 'flex !important',
  justifyContent: 'space-between !important',
  '&:hover': {
    backgroundColor: 'black'
  }
}))

export const OptionCounterparty = styled('span')({
  color: '#D3D3D3',
  fontSize: '14px',
  fontStyle: 'italic',
  marginLeft: '4px'
})

export const InputBaseStyle = styled(TextField)(({ theme, error, background = 'transparent' }) => {
  let border = 'none'

  if (error === 'true') {
    border = `1px solid ${theme.palette.button.delete.primary}`
  }

  return {
    border,
    width: '100%',
    height: '32px',
    fontFamily: 'Nunito',
    fontSize: '14px',
    background: 'transparent',
    borderRadius: '4px',
    '& .MuiTextField-root': {
      height: '32px',
      '-webkit-flex-direction': 'row',
      backgroundColor: 'transparent !important',
      border: '1px solid black !important',
      borderRadius: '4px'
    },
    '& .MuiFormControl-root': {
      display: 'block',
      padding: 0
    },
    '& .MuiInputBase-input': {
      paddingTop: '8px',
      paddingBottom: '8px',
      paddingRight: '12px',
      paddingLeft: '8px',
      background: background
    }
  }
})

export const ButtonGroupStyle = styled(ButtonGroup)(() => ({
  display: 'flex',
  width: '100%'
}))

export const SideButton = styled(Button)(({ theme, select }) => {
  let backgroundColorHover = theme.palette.tabs.backgroundColor.hover
  let backgroundColor = 'transparent'
  let color = theme.palette.button.edit.primary
  if (select === 'true') {
    backgroundColor = theme.palette.button.edit.primary
    color = theme.palette.tabs.backgroundColor.primary
    backgroundColorHover = theme.palette.button.edit.hover
  }

  return {
    flex: 1,
    border: `1px solid ${theme.palette.button.edit.primary}`,
    borderRadius: '4px',
    color,
    fontSize: '14px',
    backgroundColor,
    '&:hover': {
      border: `1px solid ${theme.palette.button.edit.primary}`,
      backgroundColor: `${backgroundColorHover}`
    },
    '&:disabled': {
      border: `1px solid #707079`,
      color: '#707079'
    }
  }
})

export const TextFieldStyle = styled(TextField)(({ theme, myerror, value }) => {
  let color = 'white !important'
  if (!value) {
    color = 'grey'
  }
  return {
    border: myerror === 'true' ? `1px solid ${theme.palette.button.delete.primary}` : 'none',
    borderRadius: '4px',
    width: '100%',
    '& input[type="date"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="date"]::-moz-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="datetime-local"]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& input[type="datetime-local"]::-moz-calendar-picker-indicator': {
      cursor: 'pointer',
      backgroundImage: `url(${calendarImage})`
    },
    '& .MuiInputBase-input': {
      padding: '11px 8px',
      color
    }
  }
})

export const FormError = styled(Typography)(({ theme }) => ({
  color: theme.palette.button.delete.primary,
  fontSize: '14px',
  display: 'blocked',
  position: 'absolute'
}))

export const PutCallButton = styled(Button)(({ theme, select }) => {
  let backgroundColorHover = theme.palette.tabs.backgroundColor.hover
  let backgroundColor = 'transparent'
  let color = theme.palette.button.text.primary
  if (select === 'true') {
    backgroundColor = theme.palette.button.text.primary
    color = theme.palette.tabs.backgroundColor.primary
    backgroundColorHover = theme.palette.button.save.hover
  }

  return {
    flex: 1,
    border: `1px solid ${theme.palette.button.text.primary}`,
    borderRadius: '4px',
    color,
    fontSize: '14px',
    backgroundColor,
    '&:hover': {
      border: `1px solid ${theme.palette.button.text.primary}`,
      backgroundColor: `${backgroundColorHover}`
    },
    '&.MuiButtonBase-root.MuiButton-root.Mui-disabled': {
      backgroundColor: 'transparent',
      color: theme.palette.button.disable,
      border: `1px solid ${theme.palette.button.disable}`
    }
  }
})
